export default __webpack_public_path__ + "static/media/INSPECT-TECH-IMG.e9ec6c7a.gif";